// Generated by `yarn tokens:import --aos-ds` from the Figma component set "RadioButton" (7419:109977). Do not edit.
//
// The "disabled" and "hover" axes are interaction state, so it is not a prop: hover and hovered are `hover:`, pressed is `active:`, focus is `focus:`,
// and disabled is applied in JS because react-native-web renders a div, which
// Tailwind's `disabled:` never matches.

import type { FigmaGlyph } from '../../icons/glyph'

export type ContractProp =
    | { kind: 'enum'; values: readonly string[] }
    | { kind: 'boolean' }
    | { kind: 'text' }
    | { kind: 'instance_swap' }
    // A matrix can carry slots too — Modal/Footer has two.
    | { kind: 'slot' }

export type ContractComposition = { component: string; variants: readonly string[] }

export type ContractVariant = {
    container: string
    label: string
    // The surface, when the paint sits on a child rather than the root:
    // empty for every component that paints its own frame.
    box: string
    // Every named node the variant draws beyond those two, keyed by the
    // name Figma gives it. A key that reads as a value rather than a role
    // means the component is a composition, not a primitive.
    parts: Record<string, string>
    // The shape of every part that is one — a VECTOR drawn on top of
    // something the variant also paints, which the whole-variant `glyph`
    // cannot describe because that one requires no paint at all.
    glyphs: Record<string, FigmaGlyph>
    // The glyph the variant draws, inked separately from the label.
    icon: string
    // Applied in JS: `disabled:` never matches a react-native-web div, and
    // `:visited` exists only on an anchor.
    disabled: string
    visited: string
    // Which of `textStyleIds` each text part is set in. The ids are a set,
    // so a component with two says two exist and not which part uses which.
    partTextStyles: Record<string, string>
    // What this cell instantiates, and which variant of it.
    composes: readonly ContractComposition[]
}

export const radiobuttonContract = {
    component: 'RadioButton',
    nodeId: '7419:109977',
    section: '[Web] Primitives',
    // Components a variant instantiates, with the variant keys used.
    // Where one of these carries the component's own paint rather than
    // a glyph, the classes below describe only what is left — Checkbox
    // swaps a whole box here.
    composes: [
        { component: 'RadioButtonSelected', variants: [] },
        { component: 'RadioButtonUnselected', variants: [] },
    ],
    stateAxis: 'disabled',
    // Where the caller puts content. One `ReactNode` prop per name.
    slots: [] as readonly string[],
    textStyleIds: ['S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,'],
    props: {
        labelText: { kind: 'text' },
        selected: { kind: 'boolean' },
        showLabel: { kind: 'boolean' },
    },
    variants: {
        'selected=false': {
            container: 'group/radiobutton gap-m h-[1.375rem] items-center',
            label: 'text-content-default text-left',
            icon: '',
            disabled: 'opacity-disabled',
            visited: '',
            box: 'border-action-grey-action border-2 rounded-badge-round w-[1.25rem] h-[1.25rem] hover:border-action-grey-action-hover',
            parts: {
                'radio frame':
                    'border-action-grey-action border-2 rounded-badge-round w-[1.25rem] h-[1.25rem] group-hover/radiobutton:border-action-grey-action-hover',
                'label': 'text-content-default text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                label: 'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
            } as Record<string, string>,
            composes: [{ component: 'RadioButtonUnselected', variants: [] }],
        },
        'selected=true': {
            container: 'group/radiobutton gap-m h-[1.375rem] items-center',
            label: 'text-content-default text-left',
            icon: '',
            disabled: 'opacity-disabled',
            visited: '',
            box: 'bg-action-default border-action-default border-2 rounded-badge-round w-[0.75rem] h-[0.75rem] hover:bg-action-hover hover:border-action-hover',
            parts: {
                'radio frame':
                    'border-action-default border-2 rounded-badge-round w-[1.25rem] h-[1.25rem] group-hover/radiobutton:border-action-hover',
                'radio fill':
                    'bg-action-default rounded-badge-round w-[0.75rem] h-[0.75rem] group-hover/radiobutton:bg-action-hover',
                'label': 'text-content-default text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                label: 'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
            } as Record<string, string>,
            composes: [{ component: 'RadioButtonSelected', variants: [] }],
        },
    },
} as const satisfies {
    component: string
    nodeId: string
    section: string
    composes: readonly ContractComposition[]
    stateAxis: string | null
    slots: readonly string[]
    textStyleIds: readonly string[]
    props: Record<string, ContractProp>
    variants: Record<string, ContractVariant>
}
